import { render, staticRenderFns } from "./SingleTask.vue?vue&type=template&id=68e86480&"
import script from "./SingleTask.vue?vue&type=script&lang=js&"
export * from "./SingleTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports